import {useNavigate} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";

import Meta from "../common/Meta";
import {AppContext} from "../../lib/AppContext";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Footer from "../Footer";
import {getCashDrawers, getPreviousCashEntry, saveCashEntry} from "../common/api/InventoryApi";
import {InputAdornment, NativeSelect} from "@mui/material";
import {useForm} from "react-hook-form";
import {Col, Row} from "react-bootstrap";
import {CompanyContext} from "../../lib/CompanyContext";
import MDInput from "../../components/MDInput";
import {CONSTANTS} from "../common/constants";
import MDButton from "../../components/MDButton";

export default function CashEntry(props) {

  const [context, setContext] = useContext(AppContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const navigate = useNavigate();

  const [companyCode, setCompanyCode] = useState(null);

  useEffect(() => {
    setCompanyCode(companyContext?.company?.preferences?.currency)
  }, [companyContext?.company?.preferences?.currency]);

  const [entryUserName, setEntryUserName] = useState();
  const [discrepancyReason, setDiscrepancyReason] = useState();
  const [expectedValue, setExpectedValue] = useState(0);

  const [contextType, setContextType] = useState(null);
  const [cashDrawer, setCashDrawer] = useState(null);
  const [cashDrawers, setCashDrawers] = useState(null);
  const [previousEntry, setPreviousEntry] = useState(null);

  const [saving, setSaving] = useState(false);

  const [contextTypes, setContextTypes] = useState([...CONSTANTS.REGISTER_CONTEXT_TYPE]);

  const handleSave = (formData) => {
    setSaving(true);
    let _entry = {...formData};
    _entry.expectedValue = previousEntry?.calculatedValue || 0;
    _entry.calculatedValue = totalCents;
    _entry.register = cashDrawer;
    saveCashEntry(_entry).then((resp) => {
      setSaving(false);
      let _context = {...context};
      _context.toast = {
        message: 'Entry Added Successful',
      }
      setContext({..._context});
      navigate('/cash/register-report')
    })
  }

  const loadDrawers = () => {
    getCashDrawers().then((resp) => {
      setCashDrawers(resp);
    })
  }

  useEffect(() => {
    loadDrawers();
  }, [])

  const {
    register, handleSubmit,
    setValue,
    control,
    reset,
    formState: {errors}
  } = useForm({});

  const handleRegisterChange = (e) => {
    if (!e.target.value) {
      setCashDrawer(null);
      setPreviousEntry(null);
      return;
    }
    for (let j in cashDrawers) {
      if (cashDrawers[j].id === parseInt(e.target.value)) {
        setCashDrawer(cashDrawers[j])
        getPreviousCashEntry(cashDrawers[j].guid).then((resp) => {
          setPreviousEntry(resp);
        })
      }
    }
  }

  const handleContextChange = (e) => {
    if (!e.target.value) {
      setContextType(null);
      return;
    }
    for (let j in contextTypes) {
      if (contextTypes[j].id === parseInt(e.target.value)) {
        setContextType(contextTypes[j]);
      }
    }
  }

  const denominations = [
    {
      id: "usd-penny",
      countryCode: "USD",
      cents: 1,
      type: "coin",
      name: "Penny"
    },
    {
      id: "usd-nickel",
      countryCode: "USD",
      cents: 5,
      type: "coin",
      name: "Nickel"
    },
    {
      id: "usd-dime",
      countryCode: "USD",
      cents: 10,
      type: "coin",
      name: "Dime"
    },
    {
      id: "usd-quarter",
      countryCode: "USD",
      cents: 25,
      type: "coin",
      name: "Quarter"
    },
    {
      id: "usd-half-dollar",
      countryCode: "USD",
      cents: 50,
      type: "coin",
      name: "Half Dollar"
    },
    {
      id: "usd-dollar-coin",
      countryCode: "USD",
      cents: 100,
      type: "coin",
      name: "Dollar Coin"
    },

    {
      id: "usd-1-bill",
      countryCode: "USD",
      cents: 100,
      type: "bill",
      name: "$1 Bill"
    },
    {
      id: "usd-2-bill",
      countryCode: "USD",
      cents: 200,
      type: "bill",
      name: "$2 Bill"
    },
    {
      id: "usd-5-bill",
      countryCode: "USD",
      cents: 500,
      type: "bill",
      name: "$5 Bill"
    },
    {
      id: "usd-10-bill",
      countryCode: "USD",
      cents: 1000,
      type: "bill",
      name: "$10 Bill"
    },
    {
      id: "usd-20-bill",
      countryCode: "USD",
      cents: 2000,
      type: "bill",
      name: "$20 Bill"
    },
    {
      id: "usd-50-bill",
      countryCode: "USD",
      cents: 5000,
      type: "bill",
      name: "$50 Bill"
    },
    {
      id: "usd-100-bill",
      countryCode: "USD",
      cents: 10000,
      type: "bill",
      name: "$100 Bill"
    },

    {
      id: "cad-nickel",
      countryCode: "CAD",
      cents: 5,
      type: "coin",
      name: "Nickel"
    },
    {
      id: "cad-dime",
      countryCode: "CAD",
      cents: 10,
      type: "coin",
      name: "Dime"
    },
    {
      id: "cad-quarter",
      countryCode: "CAD",
      cents: 25,
      type: "coin",
      name: "Quarter"
    },
    {
      id: "cad-loonie",
      countryCode: "CAD",
      cents: 100,
      type: "coin",
      name: "Loonie"
    },
    {
      id: "cad-toonie",
      countryCode: "CAD",
      cents: 200,
      type: "coin",
      name: "Toonie"
    },
    {
      id: "cad-5-bill",
      countryCode: "CAD",
      cents: 500,
      type: "bill",
      name: "$5 Bill"
    },
    {
      id: "cad-10-bill",
      countryCode: "CAD",
      cents: 1000,
      type: "bill",
      name: "$10 Bill"
    },
    {
      id: "cad-20-bill",
      countryCode: "CAD",
      cents: 2000,
      type: "bill",
      name: "$20 Bill"
    },
    {
      id: "cad-50-bill",
      countryCode: "CAD",
      cents: 5000,
      type: "bill",
      name: "$50 Bill"
    },
    {
      id: "cad-100-bill",
      countryCode: "CAD",
      cents: 10000,
      type: "bill",
      name: "$100 Bill"
    }
  ];

  const [counts, setCounts] = useState({});

  const updateCount = (d, delta) => {
    setCounts(prev => ({
      ...prev,
      [d.id]: delta
    }));
  };

  const total = denominations.reduce(
    (sum, d) => sum + (counts[d.cents] || 0) * d.cents,
    0
  );

  const setQuantity = (id, quantity) => {
    setCounts(prev => ({
      ...prev,
      [id]: Math.max(0, quantity)
    }));
  };

  const increment = (id) => {
    setCounts(prev => ({
      ...prev,
      [id]: (prev[id] || 0) + 1
    }));
  };

  const decrement = (id) => {
    setCounts(prev => ({
      ...prev,
      [id]: Math.max(0, (prev[id] || 0) - 1)
    }));
  };

  const totalCents = denominations.reduce(
    (sum, d) => sum + (counts[d.id] || 0) * d.cents,
    0
  );

  return (

    <DashboardLayout>

      <Meta pageTitle={'Cash Entry'}/>

      <ContextSearchNavbar title="Cash Entry"/>

      <MDBox py={3}>
        <MDBox mb={3}>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card>
                <MDBox p={3} lineHeight={1}>

                  <Row>
                    <Col className={'col col py-2 py-sm-0'} sm={4} xs={12}>
                      <div className="form-group native-margin-fix">
                        <label htmlFor={"state"} className={"native-label mt-n3"}>Cash Drawer</label>
                        <NativeSelect
                          autoComplete="off"
                          variant="outlined"
                          id={'register'} name={'register'} className={'form-control'}
                          {...register('register', {
                            valueAsNumber: true,
                            min: 1,
                            onChange: (e) => {
                              handleRegisterChange(e);
                            }
                          })}>
                          <option>Choose Register</option>
                          {
                            cashDrawers?.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>
                      </div>
                    </Col>

                    <Col className={'col col py-2 py-sm-0'} sm={4} xs={12}>
                      <div className="form-group native-margin-fix">
                        <label htmlFor={"contextType"} className={"native-label mt-n3"}>Entry Type</label>
                        <NativeSelect
                          required
                          autoComplete="off"
                          variant="outlined"
                          id={'contextType'} name={'contextType'} className={'form-control'}
                          {...register('contextType.id', {
                            min: 1,
                            required: true,
                            valueAsNumber: true,
                            onChange: (e) => {
                              handleContextChange(e);
                            },
                            validate: (value) => value > 0 || 'Please select a valid option',
                          })}>
                          <option>Choose Entry Type</option>
                          {
                            contextTypes?.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>
                      </div>
                    </Col>
                    <Col className={'col col text-right'} sm={4} xs={12}>

                      {previousEntry && <>
                        <MDInput type="text" style={{
                          marginTop: '-4px'
                        }}
                                 InputProps={{
                                   startAdornment: <InputAdornment position="start">
                                     <span className={'fa fa-dollar-sign'}></span>
                                   </InputAdornment>
                                 }}
                                 variant="outlined"
                                 disabled={true}
                                 value={(previousEntry.calculatedValue || 0).toFixed(2)}
                                 InputLabelProps={{shrink: true}}
                                 className="form-control" id="lastName"
                                 placeholder={"Previous Entry"}
                                 label="Previous Entry"/>
                      </>}

                    </Col>

                  </Row>


                  {cashDrawer && <>

                    <form
                      onSubmit={handleSubmit(handleSave)} id={'manageInventoryEventForm'}>

                      <Grid container mt={2}>
                        <Grid item xs={12}>
                          <table className={'table table-striped'}>
                            <thead>
                            <tr>
                              <th>Denomination</th>
                              <th width={"10%"} className={'text-right'}>Value</th>
                              <td width={"10%"}>&nbsp;</td>
                              <th>Quantity</th>
                              <th className={'text-right'}>Total Value</th>
                            </tr>
                            </thead>
                            <tbody>
                            {denominations.filter((d) => d.countryCode === companyCode).map(d => {

                              const quantity = counts[d.id] || 0;
                              const lineTotal = (quantity * d.cents) / 100;

                              return (
                                <tr key={`${d.countryCode}-${d.cents}-${d.type}`}>
                                  <td>{d.name}</td>

                                  <td width={"10%"} className={'text-right'}>${(d.cents / 100).toFixed(2)}</td>

                                  <td>&nbsp;</td>
                                  <td>

                                    <MDInput type="text" step="1" required
                                             onChange={(e) =>
                                               setQuantity(
                                                 d.id,
                                                 Number(e.target.value) || 0
                                               )
                                             }
                                             InputProps={{
                                               startAdornment: <InputAdornment position="start"
                                                                               className={'cursor-pointer'}
                                                                               onClick={(e) => {
                                                                                 decrement(d.id)
                                                                               }}>
                                                 <span className={'fa fa-minus'}></span>
                                               </InputAdornment>,
                                               endAdornment: <InputAdornment position="end"
                                                                             className={'cursor-pointer'}
                                                                             onClick={(e) => {
                                                                               increment(d.id)
                                                                             }}>
                                                 <span className={'fa fa-plus'}></span>
                                               </InputAdornment>,
                                             }}
                                             value={quantity}
                                             autoComplete="off"
                                             className="form-control pull-left" id="quantity"
                                             style={{width: '125px'}}/>


                                  </td>

                                  <td className={'text-right'}>${lineTotal.toFixed(2)}</td>
                                </tr>
                              );
                            })}
                            </tbody>

                            <tfoot>
                            <tr>
                              <td colSpan={4}>
                                <strong>Drawer Total</strong>
                              </td>
                              <td className={'text-right'}>
                                <strong>${(totalCents / 100).toFixed(2)}</strong>
                              </td>
                            </tr>
                            </tfoot>
                          </table>

                          <Row>
                            <Col sm={4} xs={12}>
                              <MDInput type="text"
                                       InputLabelProps={{shrink: true}}
                                       required
                                       autoComplete={'off'}
                                       variant="outlined"
                                       {...register('entryUserName')}
                                       className="form-control" id="code" aria-describedby="entryUserName"
                                       label="Enter Name"/>
                            </Col>
                            <Col sm={3} xs={12}>

                              <MDInput type="text"
                                       {...register('discrepancyValue', {
                                         valueAsDouble: true,
                                       })}
                                       onChange={(e) => {
                                         e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                       }}
                                       InputProps={{
                                         startAdornment: <InputAdornment position="start">
                                           <span className={'fa fa-dollar-sign'}></span>
                                         </InputAdornment>
                                       }}
                                       InputLabelProps={{shrink: true}}
                                       label="Discrepancy Value"
                                       defaultValue={"0.00"}
                                       placeholder="Enter Discrepancy Value"
                                       className="form-control"
                                       autoComplete="off"
                                       id="discrepancyValue"/>

                            </Col>
                            <Col sm={5} xs={12}>
                              <textarea
                                {...register('discrepancyReason')}
                                className="form-control w-100" id="discrepancyReason"
                                placeholder="List any discrepancies"/>

                            </Col>
                          </Row>
                          <Row className={'mt-2'}>
                            <Col xs={12}>
                              <MDButton type="submit" color="info" className={'pull-right'} disabled={saving}>
                                {saving ? 'Saving...' : 'Save'}
                              </MDButton>
                            </Col>
                          </Row>


                        </Grid>
                      </Grid>
                    </form>
                  </>
                  }

                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>

      <Footer mt={5}/>

    </DashboardLayout>
  )
    ;

}